import { render, staticRenderFns } from "./FundingAssessorRequestsShow.vue?vue&type=template&id=16220994&"
import script from "./FundingAssessorRequestsShow.vue?vue&type=script&lang=js&"
export * from "./FundingAssessorRequestsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports